module.exports = __webpack_public_path__ + "static/media/glitch-light2.0f15c38e.webp";